var parallel = require("./browser").default;
module.exports = parallel;



//////////////////
// WEBPACK FOOTER
// ./src/api/browser-commonjs.js
// module id = 159
// module chunks = 0